/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DwhFeedControllerFeedSalesOfSolesMemberDayFact$Params {

/**
 * Inclusive
 */
  startDate?: string;

/**
 * Exclusive
 */
  endDate?: string;
}

export function dwhFeedControllerFeedSalesOfSolesMemberDayFact(http: HttpClient, rootUrl: string, params?: DwhFeedControllerFeedSalesOfSolesMemberDayFact$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, dwhFeedControllerFeedSalesOfSolesMemberDayFact.PATH, 'post');
  if (params) {
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

dwhFeedControllerFeedSalesOfSolesMemberDayFact.PATH = '/api/dwh/feed/salesOfSolesMemberDayFact';
